import { render, staticRenderFns } from "./LeadFormItem.vue?vue&type=template&id=355a5130&"
import script from "./LeadFormItem.vue?vue&type=script&lang=js&"
export * from "./LeadFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports